import {RankDirection} from "../Containers/Customer/VOSS/Subscriptions/SubscriptionMainInfo";
import {VossSubscriptionItemStatus} from "../Constants/VOSS/vossSubscriptionItemStatus";
import {VossTierTagType} from "../Constants/VOSS/vossTierTagType";
import {vossSubscriptionConnectionType} from "../Constants/VOSS/vossSubscriptionConnectionType";
import {VossScheduledChangeStatus} from "../Constants/VOSS/vossScheduledChangeStatus";
import dateUtils from "./dateUtils";

const subscriptionUtils = {
    tierIsNonInteractive(tier) {
        return tier?.externalId?.toLowerCase().includes('noninteractive') || false;
    },
    
    findDependentByRank(subscriptions, subscription, direction) {
        if (!subscription?.tier?.tags || !subscriptions) return null;
        const compare = direction === RankDirection.LOWER
            ? (a, b) => b.rank < a.rank
            : (a, b) => b.rank > a.rank;

        return subscriptions.find(s => {
            if (s.id === subscription.id || !s.tier?.tags || s.status !== VossSubscriptionItemStatus.Active) {
                return false;
            }
            return subscription.tier.tags.some(currentTag =>
                s.tier?.tags.some(otherTag =>
                    currentTag.tag === otherTag.tag &&
                    otherTag.type === VossTierTagType.Require &&
                    compare(currentTag, otherTag)
                )
            );
        });
    },

    isInCollaboration(subscription) {
        return subscription?.connections?.some(conn => conn.type === vossSubscriptionConnectionType.Collaboration) || false;
    },

    getPendingScheduledChanges(subscription) {
        return subscription?.scheduledChanges?.filter(c =>
            c.status === VossScheduledChangeStatus.Pending ||
            c.status === VossScheduledChangeStatus.CompletedForUpcomingPeriod
        ) ?? [];
    },

    hasEvergreenBindingPeriod(subscription) {
        return !!subscription?.bindingPeriod && (subscription.bindingPeriod.endDate ?? null) === null;
    },

    hasEvergreenBillingPeriod(subscription) {
        return !!subscription?.subscriptionBillingPeriod && (subscription.subscriptionBillingPeriod.endDate ?? null) === null;
    },

    formatPeriodEnd(date, t) {
        return date === null || date === undefined ? t('subscriptions.untilFurtherNotice') : dateUtils.formatDate(date);
    },

    formatPeriodSpan(startDate, endDate, t) {
        return `${dateUtils.formatDate(startDate)} - ${this.formatPeriodEnd(endDate, t)}`;
    }
};

export default subscriptionUtils;